module.exports = __webpack_public_path__ + "img/secret-film.bc401d2f.png";